import { useCallback } from "react"
import useModal from "../../../../components/ModalProvider/useModal"
import { useECommerceMachine } from "../../../_common/machines/machines-context"
import { useValidateWebQuoteCommand } from "../../_common/machines/ecommerce-machine/data-loading/validate-web-quote-command-machine"
import { useReceiptReadModel } from "../../_common/machines/receipt-machine"
import { useSuiteCategoriesReadModel } from "../../_common/machines/suite-categories-machine"
import { buildPageDataLayer, pushToDataLayer } from "../../_common/tracking/page-data-layer"
import { isWebQuoteSubmitting } from "./WebQuoteModal"

export const useOnCloseWebQuoteModal = (selectBooking?: () => void) => {
    const [state, send] = useECommerceMachine()
    const [stateRP] = useReceiptReadModel(state)
    const [stateSCRM] = useSuiteCategoriesReadModel(state)
    const [stateWQ] = useValidateWebQuoteCommand(state)
    const { closeModal } = useModal()

    const isSubmitting = isWebQuoteSubmitting(stateWQ)

    const pageDataLayer = buildPageDataLayer(
        state,
        stateSCRM,
        stateRP,
        state.context.flowVersion.tracking.step(state.context.activeStep),
    )

    return useCallback(() => {
        if (isSubmitting) return
        pushToDataLayer(pageDataLayer)
        //NOTE: removed because on mobile at 'Suite assignment' step, when we click
        // Price details -> Receive quote -> Back on browser (or close with X)
        // we were calling close('closeWithCallback') twice, inside the modal and here.
        // I keep it here to see if the bug appears again. Unfortunately this part is very brittle
        //closeModal("closeWithCallback")
        selectBooking?.()
    }, [isSubmitting, JSON.stringify(pageDataLayer), closeModal, send, selectBooking])
}
